import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const patentStateApi = generateNomenApi(`/nomen/patent-state`);

export const patentStateOptions = generateNomenOptions('patent-state', patentStateApi);
